import { Component, OnInit, Input } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { GlobalService } from '@common/global';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { SaveService } from '@services/save.service';
import * as _ from 'lodash';
import { Router, ActivatedRoute, Params } from '@angular/router';
@Component({
  selector: 'app-dplaudioedit',
  templateUrl: './dplaudioedit.component.html',
  styleUrls: ['./dplaudioedit.component.sass']
})
export class DplaudioeditComponent implements OnInit {
  @Input('res') res: object;
  statusForm: FormGroup;
  component = "";
  application = "";
  response: any = [];
  status = "";
  name = "";
  bio: any = [];
  constructor(private router: Router, private _save: SaveService, private _viewService: ViewService, private fb: FormBuilder, private _global: GlobalService, public ngxSmartModalService: NgxSmartModalService) {

    this.statusForm = this.fb.group({
      status: []
    });
    this.component = this._global.COMPONENTS_SMN;
    this.application = 'member';

  }

  ngOnInit() {
  }
  ngOnChanges() {
    this.response = this.res;
    this.name = this._global.getVal(this.response, 'firstName', '') + "  " + this._global.getVal(this.response, 'lastName', '');
    this.bio = this._global.getVal(this.response, 'bio', {});
    this.status = this._global.getVal(this.bio, 'status', '');
    this.statusForm.get('status').setValue(this.status);

  }
  update() {
    let r = this.statusForm.value;
    let pa = this._global.paramsRemoveNull(r);
    this.bio['status'] = pa.status;
    let p = {
      'component': this.component,
      'application': this.application,
      'id': this._global.getSessionVal('id'),
      'bio': JSON.stringify(this.bio)
    };
    this._save.appUpdate(p).subscribe(
      data => {
        this.router.navigate['/my'];
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {

        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }

}
